import axios from 'axios';
import { env } from 'env';
import {
  IMapTemplateRecord,
  IMapTemplatesResponse,
} from '@shared/interfaces/mapTemplate';

export default class MapTemplateService {
  static getMapTemplates(
    mapId: string,
    params: { limit?: number; startKey?: string } = {},
  ): Promise<IMapTemplatesResponse> {
    const searchParams = new URLSearchParams();
    if (params.limit != null) {
      searchParams.set('limit', String(params.limit));
    }
    if (params.startKey) {
      searchParams.set('startKey', params.startKey);
    }
    const query = searchParams.toString();
    const url = `${env.REACT_APP_API_URL}api/v2/maps/${mapId}/templates${
      query ? `?${query}` : ''
    }`;
    return axios.get<IMapTemplatesResponse>(url).then((res) => res.data);
  }

  static getActiveMapTemplate(
    mapId: string,
  ): Promise<IMapTemplateRecord | null> {
    const url = `${env.REACT_APP_API_URL}api/v2/maps/${mapId}/templates/active`;
    return axios
      .get<IMapTemplateRecord | null>(url)
      .then((res) => res.data || null);
  }
}
